// extracted by mini-css-extract-plugin
export default {"input":"A1l3bWuBRnnF1IqlywVh","span":"gkNgRozGR2EOimwSx5nQ"};